import type { KeyboardLayout } from '@/graphql/graphql';
import { DEFAULT_LOCALE } from '@/lib/constants';
import { lookupKeyboardLayout } from '@/lib/keyboard-layout';

export function lookupLocale<T>(locale: Locale, lookup: Record<Locale, T>) {
  return lookup?.[locale] ?? lookup?.[DEFAULT_LOCALE];
}

export function lookupLocaleKeyboardLayout<T>(
  locale: Locale,
  keyboardLayout: KeyboardLayout,
  lookup: Record<Locale, Record<KeyboardLayout, T | undefined>>,
): T {
  const lookedupLocale = lookupLocale(locale, lookup);

  return lookupKeyboardLayout(keyboardLayout, lookedupLocale);
}
